export const ACTIVE_INSTANCE_AUTHENTICATION_NAME_KEY = 'INFRASTRUKTUR_ACTIVE_INSTANCE_AUTHENTICATION_NAME_KEY';
export const INSTANCE_AUTHENTICATION_CONFIGURATION_KEY = 'INFRASTRUKTUR_AUTHENTICATION_CONFIGURATION_KEY';
